import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FireInTheHole2} from "../FireInTheHole2";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {BitmapText, Sprite} from "pixi.js";
import {FITH2Symbol} from "../symbols/FITH2Symbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {FITH2WinConfig} from "../configs/FITH2WinConfig";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {FSSymbolTypes} from "../symbols/freespin/FreespinSymbol";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";

export class FITH2Helper {

    public static isGameStarted: boolean = false;

    /**
     * Use this method to catch the position from the TransformWorld between two objects in two different containers/layers.
     * @param objToSet Uses the  PIXI.DisplayObject's container to remove the it's offset.
     * @param objToMimic PIXI.DisplayObject to copy the position from.
     * @param position — The world origin to calculate from.
     * @returns {PIXI.Point} Mimiced position.
     */
    public static copyLocalPosition(objToSet: PIXI.DisplayObject, objToMimic: PIXI.DisplayObject | undefined, position?: PIXI.Point | undefined): PIXI.Point {
        return <PIXI.Point>objToSet.parent.toLocal(objToSet.parent.position, objToMimic, position);
    }

    public static getBigWinLevel(): number {
        return 1;
    }

    public static removeNumbersInString(str: string): string {
        return str.replace(/[0-9]/g, '');
    }

    public static checkIfSymbolIsNull(symbol: FITH2Symbol): void {
        if (symbol == null) {
            debugger;
            throw new Error(`AvalancheReelPartAnimator.animateAllIn, symbol is null!`);
        }
    }

    public static isLargerSymbol(symName: string): boolean {
        return FITH2Symbol.SPECIAL_SYMBOLS.indexOf(symName) > -1;
    }

    public static isNormal(mode: string): boolean {
        return mode[0] === "N";
    }

    public static isFreeSpin(mode: string): boolean {
        return mode[0] === "F";
    }

    public static isRespin(mode: string): boolean {
        return mode.indexOf("AVALANCHE") > -1;
    }

    public static isInvisibleSym(symName: string): boolean {
        return symName === "BA";
    }

    public static getSymbolType(symName: string): FSSymbolTypes {
        if (symName === "M") {
            return FSSymbolTypes.MISS;
        }

        if (symName === "D") {
            return FSSymbolTypes.DIRT;
        }

        if (symName[1] === "Y") {
            return FSSymbolTypes.DYNAMITE;
        }

        if (symName === "N" || symName === "PN") {
            return FSSymbolTypes.NECROMANCER;
        }

        if (FITH2Helper.isReelMultiplier(symName)) {
            return FSSymbolTypes.MULTIPLIER;
        }

        if (FITH2Helper.isCollector(symName)) {
            return FSSymbolTypes.COLLECTOR;
        }

        return FSSymbolTypes.COIN;
    }

    public static isCollector(symName: string): boolean {
        return symName === "DC" || symName === "PD";
    }

    public static isCoin(symName: string): boolean {
        return symName[0] === "C";
    }

    public static isDynamite(symName: string): boolean {
        if (symName.length < 2) {
            return false;
        }
        const feature: string = symName.substring(0, 2);
        return (feature === "DY" || feature === "PY");
    }

    public static isReelMultiplier(symName: string): boolean {
        return symName[0] === "R" || symName.substring(0, 2) === "PR";
    }

    public static isDwarf(symName: string): boolean {
        return symName === "DC" || symName === "PD";
    }

    public static behindDirt(symName: string): boolean {
        return symName === "DW" || symName === "DX" || symName === "DS";
    }

    public static isWild(symName: string): boolean {
        return symName === "DW" || symName === "W" || symName === "W2";
    }

    public static isBigWin(win: number, playedBetValue: number): boolean {
        if (FITH2Helper.isWinBelowStake(win)) {
            return false;
        }
        let winRatio: number = MathHelper.ceilToDecimals((win / playedBetValue), 2);
        return (winRatio >= FITH2WinConfig.WIN_RATIOS.bigWin[0].ratio);
    }

    public static copyNumberArray(arr: number[][]): number[][] {
        const temp: number[][] = [];
        arr.forEach((elements: number[]) => {
            const newElements: number[] = [];
            elements.forEach((element: number) => {
                newElements.push(element);
            });
            temp.push(newElements);
        });
        return temp;
    }

    public static hasSameNumbers(client: number[][], server: number[][]): boolean {
        for (let i: number = 0; i < client.length; i++) {
            for (let j: number = 0; j < client[i].length; j++) {
                if (client[i][j] !== server[i][j]) {
                    return false;
                }
            }
        }
        return true;
    }

    public static copyArray(arr: string[][]): string[][] {
        const temp: string[][] = [];
        arr.forEach((elements: string[]) => {
            const newElements: string[] = [];
            elements.forEach((element: string) => {
                newElements.push(element);
            });
            temp.push(newElements);
        });
        return temp;
    }

    public static get isIpad(): boolean {
        const resizeData: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            return (resizeData.width >= 955 && resizeData.width <= 965);
        } else {
            return (resizeData.height >= 955 && resizeData.height <= 965);
        }
    }

    public static getBuyFeaturePrice(): number {
        let betLevel = FireInTheHole2.apiPlugin.freeBets.hasFreeBets() ? FireInTheHole2.apiPlugin.freeBets.getBet() : FireInTheHole2.apiPlugin.betLevel.getLevel();
        let price: number = FireInTheHole2.model.gameData?.playedBetValue || parseFloat(betLevel);

        if (FireInTheHole2.model.boostedBet) {
            for (let index = 0; index < FireInTheHole2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (FireInTheHole2.model.initData.featureBuyTimesBetValue[index].name === FireInTheHole2.boostedName) {
                    price *= FireInTheHole2.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        if (FireInTheHole2.model.data.wasFeatureBuy) {
            for (let index = 0; index < FireInTheHole2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (FireInTheHole2.model.initData.featureBuyTimesBetValue[index].name === FireInTheHole2.model.buyFeatureName) {
                    price *= FireInTheHole2.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public static isWinBelowStake(value: number = -1): boolean {
        const totalWin: number = (value >= 0 ? value : FireInTheHole2.model.data.accumulatedRoundWin);
        return FireInTheHole2.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (totalWin <= this.getBuyFeaturePrice());
    }

    public static createSprite(spriteName?: string, x: number = 0, y: number = 0): Sprite {
        const sprite: Sprite = new PIXI.Sprite(spriteName ? FireInTheHole2.assetLoader.getTextures(spriteName)[0] : PIXI.Texture.EMPTY);
        sprite.position.set(x, y);
        return sprite;
    }

    public static createBitmapText(text: string, fontStyle: BitmapTextStyleOptions, anchor: PIXI.Point = new PIXI.Point(0.5, 0.5)): BitmapText {
        const bitmapText: BitmapText = new BitmapText(text, fontStyle);
        bitmapText.anchor = anchor;
        return bitmapText;
    }

    public static createDefaultSixBySixBooleanArray(): boolean[][] {
        return ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(6, () => false);
        });
    }

    public static randomBetween(min: number, max: number): number {
        return Math.floor(Math.random() * (1 + max - min) + min);
    }

    public static sum(arr: number[]): number {
        return arr.reduce((a, b) => a + b, 0);
    }

    public static resetSpineItem(item: PIXI.spine.Spine): void {
        item.skeleton.setSlotsToSetupPose();
        item.skeleton.setToSetupPose();
        item.state.clearTracks();
        item.state.setEmptyAnimation(0, 0);
    }

    public static getToggleType(): string {
        if (FireInTheHole2.model.currentWinRatio >= FITH2WinConfig.WIN_RATIOS.normalWin[3].ratio) {
            return "";
        }

        if (FireInTheHole2.model.currentWinRatio >= FITH2WinConfig.WIN_RATIOS.normalWin[2].ratio) {
            return "";
        }
        return "small";
    }
}